import { useNormalizeAssetPath } from '../../features/base/hooks/useBase';
import { AccordionItem, Position } from './interfaces';

const verticalArrows = `<svg id="icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<defs>
  <style>
    .cls-1 {
      fill: none;
    }
    .cls-2 {
      fill: #0091dc;
    }
  </style>
</defs>
<g id="up_32-g" transform="translate(0 0)">
  <g id="white_background" data-name="white background">
    <rect id="Rechteck_24838" data-name="Rechteck 24838" class="cls-1" width="32" height="32" transform="translate(0 0)"/>
  </g>
  <g id="content" transform="translate(8.998 2.002)">
    <g id="Gruppe_43712" data-name="Gruppe 43712" transform="translate(0 0)">
      <path id="Vereinigungsmenge_67" data-name="Vereinigungsmenge 67" class="cls-2" d="M0,21.3l1.379-1.417,4.154,4.3V3.82l-4.154,4.3L0,6.7,6.5,0,13,6.7,11.625,8.119l-4.16-4.3V24.18l4.16-4.3L13,21.3,6.5,28Z" transform="translate(0.002 -0.002)"/>
    </g>
  </g>
</g>
</svg>
`;

const inclineArrows = `
<svg xmlns="https://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<defs>
  <style>
    .cls-1 {
      fill: none;
    }

    .cls-2 {
      fill: #0091dc;
    }
  </style>
</defs>
<g id="icon" transform="translate(32) rotate(90)">
  <g id="up_32-g" transform="translate(0 0)">
    <g id="white_background" data-name="white background">
      <rect id="Rechteck_24838" data-name="Rechteck 24838" class="cls-1" width="32" height="32" transform="translate(0 0)"/>
    </g>
    <g id="content" transform="translate(8.998 2.002)">
      <g id="Gruppe_43712" data-name="Gruppe 43712" transform="translate(0 0)">
        <path id="Vereinigungsmenge_67" data-name="Vereinigungsmenge 67" class="cls-2" d="M0,21.3l1.379-1.417,4.154,4.3V3.82l-4.154,4.3L0,6.7,6.5,0,13,6.7,11.625,8.119l-4.16-4.3V24.18l4.16-4.3L13,21.3,6.5,28Z" transform="translate(0.002 -0.002)"/>
      </g>
    </g>
  </g>
</g>
</svg>

`;

const rotatoryArrow = `
<svg xmlns="https://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<defs>
  <style>
    .cls-1 {
      fill: none;
    }

    .cls-2 {
      fill: #0091dc;
    }
  </style>
</defs>
<g id="icon" transform="translate(32) rotate(90)">
  <g id="up_32-g" transform="translate(0 0)">
    <g id="white_background" data-name="white background">
      <rect id="Rechteck_24838" data-name="Rechteck 24838" class="cls-1" width="32" height="32" transform="translate(0 0)"/>
    </g>
    <g id="content" transform="translate(1.004 10.698) rotate(-45)">
      <g id="Gruppe_43712" data-name="Gruppe 43712" transform="translate(0 0)">
        <path id="Vereinigungsmenge_67" data-name="Vereinigungsmenge 67" class="cls-2" d="M0,21.3l1.379-1.417,4.154,4.3V3.82l-4.154,4.3L0,6.7,6.5,0,13,6.7,11.625,8.119l-4.16-4.3V24.18l4.16-4.3L13,21.3,6.5,28Z" transform="translate(0.002 -0.002)"/>
      </g>
    </g>
  </g>
</g>
</svg>

`;

const horizontalArrows = `
<svg xmlns="https://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
<defs>
  <style>
    .cls-1 {
      fill: none;
    }

    .cls-2 {
      fill: #0091dc;
    }
  </style>
</defs>
<g id="restart_32-g" transform="translate(16 16)">
  <g id="restart_32-g-2" data-name="restart_32-g" transform="translate(-16 -16)">
    <rect id="Rechteck_26807" data-name="Rechteck 26807" class="cls-1" width="32" height="32"/>
    <path id="Pfad_34345" data-name="Pfad 34345" class="cls-2" d="M16,3V5A11.066,11.066,0,1,1,9.305,7.305L13,11V3H5L7.872,5.872A12.984,12.984,0,1,0,16,3Z"/>
  </g>
</g>
</svg>

`;

const useAccordionItems = () => {
  const normalizeAssetPath = useNormalizeAssetPath();

  const verticalPositions: Position[] = [
    {
      name: 'useCaseVerticalMotionFreeFallingMass',
      url: 'Vertical-Motion_Free-falling-mass',
      filterValue: 'VERTICAL_MOTION_FREE_FALLING_MASS',
      description: 'useCaseVerticalMotionFreeFallingMassDesc',
      img: normalizeAssetPath('img/motion/vertical/TV1_150dpi.png'),
    },
    {
      name: 'useCaseVerticalMotionDownwardsMovingMassWithDrivingForce',
      url: 'Vertical-Motion_Downwards-moving-mass-with-driving-force',
      filterValue: 'VERTICAL_MOTION_DOWNWARDS_MOVING_MASS_WITH_DRIVING_FORCE',
      description: 'useCaseVerticalMotionDownwardsMovingMassWithDrivingForceDesc',
      img: normalizeAssetPath('img/motion/vertical/TV4_150dpi.png'),
    },
    {
      name: 'useCaseVerticalMotionUpwardsMovingMassWithDrivingForce',
      url: 'Vertical-Motion_Upwards-moving-mass-with-driving-force',
      filterValue: 'VERTICAL_MOTION_UPWARDS_MOVING_MASS_WITH_DRIVING_FORCE',
      description: 'useCaseVerticalMotionUpwardsMovingMassWithDrivingForceDesc',
      img: normalizeAssetPath('img/motion/vertical/TV5_150dpi.png'),
    },
  ];

  const horizontalPositions: Position[] = [
    {
      name: 'useCaseHorizontalMotionMovingMassOnRollers',
      url: 'Horizontal-Motion_Moving-mass-on-rollers',
      filterValue: 'HORIZONTAL_MOTION_MOVING_MASS_ON_ROLLERS',
      description: 'useCaseHorizontalMotionMovingMassOnRollersDesc',
      img: normalizeAssetPath('img/motion/horizontal/TH1_150dpi.png'),
    },
    {
      name: 'useCaseHorizontalMotionMovingMassWithDrivingForce',
      url: 'Horizontal-Motion_Moving-mass-with-driving-force',
      filterValue: 'HORIZONTAL_MOTION_MOVING_MASS_WITH_DRIVING_FORCE',
      description: 'useCaseHorizontalMotionMovingMassWithDrivingForceDesc',
      img: normalizeAssetPath('img/motion/horizontal/TH5_150dpi.png'),
    },
    {
      name: 'useCaseHorizontalMotionMovingMassOnBelt',
      url: 'Horizontal-Motion_Moving-mass-on-belt',
      filterValue: 'HORIZONTAL_MOTION_MOVING_MASS_ON_BELT',
      description: 'useCaseHorizontalMotionMovingMassOnBeltDesc',
      img: normalizeAssetPath('img/motion/horizontal/TH4_150dpi.png'),
    },
  ];

  const inclinePositions: Position[] = [
    {
      name: 'useCaseInclineMotionMovingMassDownwardsOnInclinedPlane',
      url: 'Incline-Motion_Moving-mass-downwards-on-inclined-plane',
      filterValue: 'INCLINE_MOTION_MOVING_MASS_DOWNWARDS_ON_INCLINED_PLANE',
      description: 'useCaseInclineMotionMovingMassDownwardsOnInclinedPlaneDesc',
      img: normalizeAssetPath('img/motion/incline/TI1_150dpi.png'),
    },
    {
      name: 'useCaseInclineMotionMovingMassDownwardsOnInclinedPlaneWithDrivingForce',
      url: 'Incline-Motion_Moving-mass-downwards-on-inclined-plane-with-driving-force',
      filterValue: 'INCLINE_MOTION_MOVING_MASS_DOWNWARDS_ON_INCLINED_PLANE_WITH_DRIVING_FORCE',
      description: 'useCaseInclineMotionMovingMassDownwardsOnInclinedPlaneWithDrivingForceDesc',
      img: normalizeAssetPath('img/motion/incline/TI5_150dpi.png'),
    },
    {
      name: 'useCaseInclineMotionMovingMassUpwardsOnInclinedPlaneWithDrivingForce',
      url: 'Incline-Motion_Moving-mass-upwards-on-inclined-plane-with-driving-force',
      filterValue: 'INCLINE_MOTION_MOVING_MASS_UPWARDS_ON_INCLINED_PLANE_WITH_DRIVING_FORCE',
      description: 'useCaseInclineMotionMovingMassUpwardsOnInclinedPlaneWithDrivingForceDesc',
      img: normalizeAssetPath('img/motion/incline/TI7_150dpi.png'),
    },
  ];

  const rotatoryPositions: Position[] = [
    {
      name: 'useCaseRotationalMotionFreelyMovingLeverAtVerticalImpact',
      url: 'Rotational-Motion_Freely-moving-lever-at-vertical-impact',
      filterValue: 'ROTATIONAL_MOTION_FREELY_MOVING_LEVER_AT_VERTICAL_IMPACT',
      description: 'useCaseRotationalMotionFreelyMovingLeverAtVerticalImpactDesc',

      img: normalizeAssetPath('img/motion/rotatory-movement/RS2_150dpi.png'),
    },
    {
      name: 'useCaseRotationalMotionDownwardsMovingLeverWithDrivingTorqueAtVerticalImpact',
      url: 'Rotational-Motion_Downwards-moving-lever-with-driving-torque-at-vertical-impact',
      filterValue: 'ROTATIONAL_MOTION_DOWNWARDS_MOVING_LEVER_WITH_DRIVING_TORQUE_AT_VERTICAL_IMPACT',
      description: 'useCaseRotationalMotionDownwardsMovingLeverWithDrivingTorqueAtVerticalImpactDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS1_150dpi.png'),
    },
    {
      name: 'useCaseRotationalMotionUpwardsMovingLeverWithDrivingTorqueAtVerticalImpact',
      url: 'Rotational-Motion_Upwards-moving-lever-with-driving-torque-at-vertical-impact',
      filterValue: 'ROTATIONAL_MOTION_UPWARDS_MOVING_LEVER_WITH_DRIVING_TORQUE_AT_VERTICAL_IMPACT',
      description: 'useCaseRotationalMotionUpwardsMovingLeverWithDrivingTorqueAtVerticalImpactDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS3_150dpi.png'),
    },
    {
      name: 'useCaseRotationalMotionUpwardsMovingLeverWithDrivingTorqueAndSideImpact',
      url: 'Rotational-Motion_Upwards-moving-lever-with-driving-torque-and-side-impact',
      filterValue: 'ROTATIONAL_MOTION_UPWARDS_MOVING_LEVER_WITH_DRIVING_TORQUE_AND_SIDE_IMPACT',
      description: 'useCaseRotationalMotionUpwardsMovingLeverWithDrivingTorqueAndSideImpactDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS4_150dpi.png'),
    },
    {
      name: 'useCaseRotationalMotionDownwardsMovingLeverWithDrivingTorqueAndSideImpact',
      url: 'Rotational-Motion_Downwards-moving-lever-with-driving-torque-and-side-impact',
      filterValue: 'ROTATIONAL_MOTION_DOWNWARDS_MOVING_LEVER_WITH_DRIVING_TORQUE_AND_SIDE_IMPACT',
      description: 'useCaseRotationalMotionDownwardsMovingLeverWithDrivingTorqueAndSideImpactDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS5_150dpi.png'),
    },
    {
      name: 'useCaseRotationalMotionFreelyMovingLeverWithSideImpact',
      url: 'Rotational-Motion_Freely-moving-lever-with-side-impact',
      filterValue: 'ROTATIONAL_MOTION_FREELY_MOVING_LEVER_WITH_SIDE_IMPACT',
      description: 'useCaseRotationalMotionFreelyMovingLeverWithSideImpactDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS6_150dpi.png'),
    },
    {
      name: 'useCaseRotationalMotionRotatingLeverOnHorizontalPlaneWithDrivingTorque',
      url: 'Rotational-Motion_Rotating-lever-on-horizontal-plane-with-driving-torque',
      filterValue: 'ROTATIONAL_MOTION_ROTATING_LEVER_ON_HORIZONTAL_PLANE_WITH_DRIVING_TORQUE',
      description: 'useCaseRotationalMotionRotatingLeverOnHorizontalPlaneWithDrivingTorqueDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS7_150dpi.png'),
    },
    {
      name: 'useCaseRotationalMotionRotatingDiskOnVerticalPlane',
      url: 'Rotational-Motion_Rotating-disk-on-vertical-plane',
      filterValue: 'ROTATIONAL_MOTION_ROTATING_DISK_ON_VERTICAL_PLANE',
      description: 'useCaseRotationalMotionRotatingDiskOnVerticalPlaneDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS9_150dpi.png'),
    },

    {
      name: 'useCaseRotationalMotionSwingingLinkageWithDrivingForce',
      url: 'Rotational-Motion_Swinging-linkage-with-driving-force',
      filterValue: 'ROTATIONAL_MOTION_SWINGING_LINKAGE_WITH_DRIVING_FORCE',
      description: 'useCaseRotationalMotionSwingingLinkageWithDrivingForceDesc',
      img: normalizeAssetPath('img/motion/rotatory-movement/RS11_150dpi.png'),
    },
  ];

  const accordionItems: AccordionItem[] = [
    {
      title: 'verticalMotion',
      key: 2,
      icon: verticalArrows,
      description: 'verticalMotionDescription',
      children: verticalPositions,
    },
    {
      title: 'horizontalMotion',
      key: 1,
      icon: inclineArrows,
      description: 'horizontalMotionDescription',
      children: horizontalPositions,
    },
    {
      title: 'inclineMotion',
      key: 3,
      icon: rotatoryArrow,
      description: 'inclineMotionDescription',
      children: inclinePositions,
    },
    {
      title: 'rotatoryMovement',
      key: 4,
      icon: horizontalArrows,
      description: 'rotatoryMovementDescription',
      children: rotatoryPositions,
    },
  ];

  return accordionItems;
};

export default useAccordionItems;
